import React from "react";
import WaitlistForm from "./WaitlistForm";

export default function FinalCTA() {
  return (
    <section id="contact" data-testid="final-cta-section" className="py-28 md:py-36 px-4 sm:px-6">
      <div className="relative max-w-6xl mx-auto bg-bhyyve-charcoal rounded-[2.5rem] sm:rounded-[3rem] overflow-hidden grain">
        {/* Background glows */}
        <div aria-hidden="true" className="absolute -top-40 -right-40 w-[500px] h-[500px] rounded-full bg-bhyyve-honey/[0.15] blur-3xl" />
        <div aria-hidden="true" className="absolute -bottom-40 -left-40 w-[500px] h-[500px] rounded-full bg-white/[0.04] blur-3xl" />

        <div className="relative px-8 sm:px-14 lg:px-24 py-24 lg:py-32 flex flex-col items-center text-center">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 px-5 py-2 rounded-full bg-white/10 border border-white/15 text-xs font-semibold tracking-wider uppercase text-bhyyve-emeraldLight mb-8">
            Founding Member Spots · Limited
          </div>

          {/* Headline */}
          <h2 data-testid="final-cta-headline" className="font-heading text-5xl sm:text-6xl lg:text-7xl tracking-tight leading-[1.02] font-medium text-white max-w-3xl">
            Don't miss your <span className="italic font-normal text-bhyyve-emeraldLight">Founding Member</span> spot.
          </h2>

          <p className="mt-7 text-xl text-white/70 max-w-xl leading-relaxed">
            Limited rewards. Early access won't last. Be one of the first to shape how local commerce works.
          </p>

          {/* Form */}
          <div className="mt-12 w-full max-w-lg flex justify-center">
            <WaitlistForm variant="final" />
          </div>
        </div>
      </div>
    </section>
  );
}
